module.exports = __webpack_public_path__ + "static/personal_data_processing_policy-59f2028add50b91cad7135f8265d66c3.pdf";